export * from './customer.service';
export * from './liquidity_account.service';
export * from './pool.service';
export * from './cards.service';
export * from './transfers.service';
export * from './tariffs.service'
export * from './available-account-types.service'
export * from './common-customer-account.service'
export * from './account-state-log.service'
export * from './iban.service'



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/api/service/index.ts